"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _data = _interopRequireDefault(require("./data"));
/**
 * Get verbiage for a specific error code and language, replacing placeholders with provided parameters.
 *
 * @param {string} errorCode - The error code for which verbiage is needed.
 * @param {string} [language='en'] - The language in which the verbiage should be retrieved (default is 'en').
 * @param {string[]} [params=[]] - An array of parameters to replace placeholders in the verbiage (default is an empty array).
 * @param skipErrorCode
 * @returns {string} The verbiage with placeholders replaced by the provided parameters, including the error code.
 */
function getVerbiage(errorCode) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var skipErrorCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!_data["default"][errorCode]) {
    throw "Failed to find the specified error code: ".concat(errorCode);
  }
  var str = _data["default"][errorCode].verbiage[language];

  // loop over the params and replace the template string with the parameter
  // eslint-disable-next-line array-callback-return
  params.map(function (param, i) {
    str = str.replace("params[".concat(i, "]"), param);
  });
  if (!skipErrorCode) {
    str += " (".concat(errorCode, ")");
  }
  return str;
}
var _default = exports["default"] = getVerbiage;